import _ from 'underscore';
import { GetJsDataInfo } from '@bingads-webui-clientcenter/js-data-cc-rest-base';

const ccJSData = {
  jsDataCcRest: null,
};

export const initCcJsData = ({ serverContext }) => {
  if (!ccJSData.jsDataCcRest) {
    const options = {
      cidFetcher: () => serverContext.CurrentCustomer.Id,
      uidFetcher: () => serverContext.CurrentUser.Id,
      appendErrorSummary: _.noop,
      handleAjaxAuthFailure: _.noop,
      willSupportCors: true,
    };

    ccJSData.jsDataCcRest = GetJsDataInfo(options, serverContext.ServicesEndpoints.ClientCenterUIAPI, []).jsDataCcRest;
  }

  return ccJSData;
};
